var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05604 2.3722C8.97488 2.37457 8.89783 2.40842 8.84119 2.4666L3.43714 7.87065L1.15809 5.5916C1.12929 5.56161 1.0948 5.53767 1.05664 5.52117C1.01847 5.50468 0.977401 5.49596 0.935826 5.49554C0.894251 5.49512 0.85301 5.50299 0.814517 5.51871C0.776025 5.53442 0.741055 5.55766 0.711655 5.58706C0.682256 5.61646 0.659018 5.65143 0.643303 5.68992C0.627588 5.72842 0.619711 5.76966 0.620133 5.81123C0.620556 5.85281 0.62927 5.89388 0.645765 5.93204C0.662259 5.97021 0.686203 6.0047 0.716195 6.0335L3.21619 8.5335C3.2748 8.59208 3.35428 8.62499 3.43714 8.62499C3.52001 8.62499 3.59948 8.59208 3.65809 8.5335L9.28309 2.9085C9.32817 2.86459 9.35895 2.80809 9.37139 2.7464C9.38384 2.68472 9.37737 2.62071 9.35284 2.56276C9.3283 2.5048 9.28684 2.45561 9.23389 2.42161C9.18093 2.38761 9.11894 2.37039 9.05604 2.3722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.195ac6656f723f0a54ebf24454589db8.svg";
export { ForwardRef as ReactComponent };